"use client";
import Image from "next/image";
import error_img from "@/assets/img/error/error.svg";
import Link from "next/link";
import HeaderOne from "@/components/header/header-one";
import FooterOne from "@/components/footer/footer-one";
import { getLocalizedPath } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";

export default function NotFound() {
  const { language } = useLanguage();
  
  return (
    <>
      <HeaderOne inner={true} />
      <main>
        <div className="tp-error-area pt-70 pb-70 breadcrumb-mt">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <div className="tp-error-wrapper text-center">
                  <h1 className="tp-section-title mb-50">
                    {language === "ar" ? "عذراً!" : "Oops!"}
                  </h1>
                  <div className="tp-error-thumb mb-50">
                    <Image src={error_img} alt="error-img" />
                  </div>
                  <div className="tp-error-content">
                    <h2 className="tp-section-3-title mb-20">
                      {language === "ar" 
                        ? "حدث خطأ ما..." 
                        : "Something Went Wrong..."
                      }
                    </h2>
                    <p>
                      {language === "ar"
                        ? "عذراً، لم نتمكن من العثور على الصفحة المطلوبة."
                        : "Sorry, we couldn't find your page."
                      }
                    </p>
                    <Link
                      aria-label="Back to Home"
                      className="tp-btn"
                      href={getLocalizedPath("/", language)}
                    >
                      {language === "ar" ? "العودة للرئيسية" : "Back to Home"}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <FooterOne />
    </>
  );
}
